var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCountryMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Instrument-Banjo--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Instrument Banjo Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.09 15.79a1 1 0 0 0 -1.42 1.42l2.12 2.12a1 1 0 0 0 1.42 0 1 1 0 0 0 0 -1.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.71 6.71a1 1 0 0 0 0 -1.42l-0.56 -0.55a0.25 0.25 0 0 1 0 -0.36l0.41 -0.4A1.52 1.52 0 0 0 24 2.92a1.5 1.5 0 0 0 -0.44 -1.06L22.14 0.44a1.51 1.51 0 0 0 -2.14 0l-0.4 0.41a0.25 0.25 0 0 1 -0.36 0l-0.53 -0.56a1 1 0 0 0 -1.42 1.42l0.56 0.55a0.25 0.25 0 0 1 0 0.36l-0.66 0.65a1 1 0 0 0 -0.29 0.73 1 1 0 0 0 0.17 0.55 0.26 0.26 0 0 1 0 0.31l-5.29 5.24a0.26 0.26 0 0 1 -0.31 0A7.4 7.4 0 0 0 7.5 9a7.48 7.48 0 1 0 6.37 3.53 0.24 0.24 0 0 1 0 -0.31L19.16 7a0.26 0.26 0 0 1 0.31 0 1 1 0 0 0 1.26 -0.12l0.65 -0.66a0.25 0.25 0 0 1 0.36 0l0.55 0.56a1 1 0 0 0 1.42 0ZM4 20a5 5 0 1 1 7 0 5 5 0 0 1 -7 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCountryMusic);
export default ForwardRef;